import { Row, Typography } from "antd";
import { useTranslation } from "react-i18next";
import "./index.less";

type BlockFanConfirmationModalProps = {
  isOpen: boolean;
  onClose: () => void;
  blockFan: () => void;
};

const BlockFanConfirmationModalComponent: React.FC<BlockFanConfirmationModalProps> = ({ isOpen, onClose, blockFan }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const handleOverlayClick = () => {
    if (onClose) {
      onClose();
    }
  };

  const handleModalClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
  };

  return (
    <div className="bottom-modal-overlay" onClick={handleOverlayClick}>
      <div className="bottom-modal-content" onClick={handleModalClick}>
        <Row className="w-full justify-content-center mt-10">
          <div className="header-icon-grey" onClick={handleOverlayClick}></div>
        </Row>
        <div className="bottom-modal-header">
          <Typography.Text className="bottom-modal-title f-28">{t("block-fan-modal-title")}</Typography.Text>
        </div>
        <div className="bottom-modal-body mt-10">
          <Typography.Text className="bottom-modal-description">{t("block-fan-modal-desc")}</Typography.Text>
          <button className="bottom-modal-button mt-14" onClick={blockFan}>
            <Typography.Text className="bottom-modal-button-title">{t("Yes-block")}</Typography.Text>
          </button>

          <button className="bottom-modal-cancel-button" onClick={onClose}>
            <Typography.Text className="bottom-modal-cancel-button-title">{t("cancel")}</Typography.Text>
          </button>
        </div>
      </div>
    </div>
  );
};

export default BlockFanConfirmationModalComponent;
